// src/pages/admin/components/GroupManagement/GroupList.js
import React from 'react';

const GroupList = ({ groups, selectedGroup, unassignedMentors, unassignedLearners, onGroupSelect, onCreateNew }) => {
  return (
    <div className="groups-list">
      <div className="list-header">
        <h3>Groups ({groups.length})</h3>
        <button className="btn-primary" onClick={onCreateNew} type="button">
          Create New Group
        </button>
      </div>

      {groups.length > 0 ? (
        <ul className="group-items">
          {groups.map(group => (
            <li
              key={group.id}
              className={`group-item ${selectedGroup?.id === group.id ? 'selected' : ''}`}
              onClick={() => onGroupSelect(group)}
            >
              <div className="group-name">{group.name}</div>
              <div className="group-meta">
                <div className="group-mentor">
                  {group.mentors?.length > 0
                    ? `${group.mentors.length} mentor${group.mentors.length !== 1 ? 's' : ''}`
                    : 'No mentors assigned'}
                </div>
                <div className="group-size">
                  {group.learners.length} learner{group.learners.length !== 1 ? 's' : ''}
                </div>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p className="empty-list">No groups found. Create a new group to get started.</p>
      )}

      <div className="unassigned-users-summary">
        <h4>Unassigned Users</h4>
        <p>Mentors: {unassignedMentors.length}</p>
        <p>Learners: {unassignedLearners.length}</p>
      </div>
    </div>
  );
};

export default GroupList;